__turbopack_context__.v({
  "imageWrap": "CategoriesList-module-scss-module__Jw32CG__imageWrap",
  "item": "CategoriesList-module-scss-module__Jw32CG__item",
  "link": "CategoriesList-module-scss-module__Jw32CG__link",
  "list": "CategoriesList-module-scss-module__Jw32CG__list",
  "root": "CategoriesList-module-scss-module__Jw32CG__root",
  "title": "CategoriesList-module-scss-module__Jw32CG__title",
});
